import React from "react";

interface CheckBoxProps {
  checked: boolean;
  onChange: () => void;
  isEnabled?: boolean;
  checkmarkColor?: string;
  borderColor?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  checked,
  onChange,
  isEnabled = true,
  checkmarkColor = "#3b4cdb",
  borderColor = "border-border-subtle",
}) => {
  return (
    <button
      type="button"
      disabled={!isEnabled}
      onClick={onChange}
      className={`flex-shrink-0 w-[18px] h-[18px] rounded-[4px] border ${borderColor} flex items-center justify-center ${
        checked ? "bg-bg-page-body" : "bg-bg-page-body"
      } disabled:opacity-50`}
      style={checked ? { borderColor: checkmarkColor } : undefined}
    >
      {checked ? (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M2.5 6L5 8.5L9.5 3.5"
            stroke={checkmarkColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : null}
    </button>
  );
};

export default CheckBox;
